export const USER_LIST = 'ROLE_User_collection_get';
export const USER_CREATE = 'ROLE_User_collection_post';
export const USER_SHOW = 'ROLE_User_item_get';
export const USER_EDIT = 'ROLE_User_item_put';
export const USER_DELETE = '';
export const USER_CUSTOM = 'ROLE_User_collection_current';